import { render, staticRenderFns } from "./LPCSuggestionPromptEditor.vue?vue&type=template&id=edfa9960"
import script from "./LPCSuggestionPromptEditor.vue?vue&type=script&lang=js"
export * from "./LPCSuggestionPromptEditor.vue?vue&type=script&lang=js"
import style0 from "./LPCSuggestionPromptEditor.vue?vue&type=style&index=0&id=edfa9960&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports